import { render, staticRenderFns } from "./EditAISearchPrompts.vue?vue&type=template&id=161e95fa&"
import script from "./EditAISearchPrompts.vue?vue&type=script&lang=js&"
export * from "./EditAISearchPrompts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports